import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { menuOptions } from './sidebar.menu';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IMenuOption, IMenuSection } from '@common/interfaces/generic/menu.interface';
import { OfficeSelectorComponent } from "../office-selector/office-selector.component";
import { PermissionValidatorService } from '@common/services/permission-validator.service';
import { CoreService } from '@common/services/core.service';
import { ProfileService } from '@modules/profile/services/profile.service';
import { inject } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, RouterModule, OfficeSelectorComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  private readonly permissionValidatorService: PermissionValidatorService = inject(PermissionValidatorService);
  private readonly coreService: CoreService = inject(CoreService);
  private readonly profileService: ProfileService = inject(ProfileService);

  menu: IMenuSection[] = [];
  showOfficeSelector: boolean = false;
  @HostBinding('class.show') @Input() show: boolean = true;
  @Output() onCloseMenu: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {
    this.showOfficeSelector = this.profileService.profile.offices.length > 1 || this.permissionValidatorService.validateRolePermission('offices:management');

    if (!this.showOfficeSelector) {
      this.coreService.setOfficeSelected(this.profileService.profile.offices[0])
    }

    this.menu = menuOptions.map((section: IMenuSection) => {
      const newSection: IMenuSection = { ...section };
      newSection.options = section.options?.filter((option: IMenuOption) => {
        return (option.active && !option.permission) || (option.active && option.permission && this.permissionValidatorService.validateRolePermission(option.permission))
      });
      return newSection;
    });
  }

  closeMenuForMobile() {
    if (window.innerWidth <= 1024) {
      this.closeMenu();
    }
  }

  closeMenu() {
    this.onCloseMenu.emit(false);
  }
}
